export enum InvoiceStatus {
  CREATED = 1,
  REVISED = 2,
  SUBMITTED = 3,
  PARTIALLY_PAID = 4,
  FULLY_PAID = 5,
  IN_REVISION = 6,
  POTENTIAL = 7
}

export enum ColorClass {
  RED = 'color-red',
  BLUE = 'color-blue',
  YELLOW = 'color-yellow',
  GREEN = 'color-green'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/invoiceStatusEnum.ts